import {
  Search,
  User,
  ShoppingBag,
  FileText,
  Home,
  UserCheck,
  ShoppingCart,
  Calendar,
  MessageCircle,
  HelpCircle,
  Calculator,
  Trophy,
} from 'lucide-react';

// Primary top-navigation links (extracted from ResponsiveHeader.jsx)
export const navItems = [
  { path: '/', label: 'Home', icon: Home },
  { path: '/search', label: 'Find Trainers', icon: Search },
  { path: '/calorie-calculator', label: 'Calorie Calculator', icon: Calculator },
  { path: '/shop', label: 'Shop', icon: ShoppingBag, highlight: true },
  { path: '/blog', label: 'Blog', icon: FileText },
  { path: '/faq', label: 'FAQ', icon: HelpCircle },
  { path: '/badges', label: 'Badges', icon: Trophy },
];

// Role-aware user dropdown menu items
export const getUserMenuItems = (user) => {
  if (!user) return [];

  const baseItems = [
    { icon: Home, label: 'Dashboard', path: user.role === 'admin' ? '/admin' : `/${user.role}/dashboard` },
  ];

  if (user.role === 'user') {
    return [
      ...baseItems,
      { icon: Calendar, label: 'My Bookings', path: '/user/bookings' },
      { icon: MessageCircle, label: 'Messages', path: '/user/messages' },
      { icon: ShoppingCart, label: 'My Orders', path: '/orders' },
    ];
  } else if (user.role === 'trainer') {
    return [
      ...baseItems,
      { icon: Calendar, label: 'Bookings', path: '/trainer/dashboard?tab=bookings' },
      { icon: MessageCircle, label: 'Messages', path: '/trainer/messages' },
    ];
  } else if (user.role === 'admin') {
    return [
      ...baseItems,
      { icon: UserCheck, label: 'Trainers', path: '/admin/trainers' },
      { icon: User, label: 'Customers', path: '/admin/users' },
    ];
  }

  return baseItems;
};
